import { ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { forkJoin, Subscription, take } from 'rxjs';
import { KbDataExtractionRequestService } from 'src/app/services/feature/data-extraction-request/kb-data-extraction-request.service';
import { RegisterService } from 'src/app/services/feature/register.service';
@Component({
  selector: 'app-kb-customer-vehicle-owner',
  templateUrl: './kb-customer-vehicle-owner.component.html',
  styleUrl: './kb-customer-vehicle-owner.component.scss',
  standalone: false
})
export class KbCustomerVehicleOwnerComponent implements OnInit, OnDestroy {

  private dataExtractionService = inject(KbDataExtractionRequestService);
  private fb = inject(FormBuilder);
  private registerService = inject(RegisterService);
  private cdr = inject(ChangeDetectorRef);

  submitted = false;



  pageFieldData: any;
  pageFieldData$ = this.registerService.getRegisterPageFields();
  accessRequestsWSList: any;
  countriesWSList: any;
  stateList: any;

  subscription = new Subscription();

  popupOpenCompanyName: boolean = false;
  popupOpenContactName: boolean = false;
  private timeout?: ReturnType<typeof setTimeout> | null = null;// Store the timeout ID
  customerForm = this.fb.group({
    companyName: ['', Validators.required],
    contactName: ['', Validators.required],
    contactEmail: ['', [Validators.required, Validators.email]],
    contactPhone: ['', Validators.required],
    address1: ['', Validators.required],
    address2: [''],
    city: ['', Validators.required],
    state: [null, Validators.required],
    country: [null as string | null, Validators.required],
    zip: ['', Validators.required],
  });

  constructor() {

  }

  ngOnInit(): void {
    forkJoin({
      countrydata: this.registerService.getRegisterPageFields().pipe(take(1)),
      stateData: this.registerService.getRegions('US').pipe(take(1))
    }).subscribe({
      next: ({ countrydata, stateData }) => {
        this.pageFieldData = countrydata;
        this.countriesWSList = this.pageFieldData.countriesWSList;
        this.stateList = stateData;
        this.timeout = setTimeout(() => {
          this.customerForm.get('country')?.setValue('US', { emitEvent: false });
          this.cdr.detectChanges();
        });
      },
      error: (err) => {
        console.error('Failed to load register fields/regions:', err);
      }
    });

    this.subscription.add(this.dataExtractionService.customerData$
      .subscribe(customerdata => {
        this.setupForm(customerdata);
      }));
  }
  back() {
    this.dataExtractionService.currentComponent$.next('dataExtractionOverview');
  }
  next() {
    this.submitted = true;
    this.dataExtractionService.setCustomerData(this.customerForm.value);
    this.dataExtractionService.currentComponent$.next('requestor');
  }
  onCountryChange(ev: any) {
    if (ev?.target?.value) {
      this.subscription.add(this.registerService.getRegions(ev.target.value).subscribe((data) => {
        this.stateList = data;
      }));
    }
    else {
      this.subscription.add(this.registerService.getRegions(ev).subscribe((data) => {
        this.stateList = data;
      }));
    }
  }
  ngOnDestroy() {
    this.subscription.unsubscribe();
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  openPopupCompanyName() {
    this.popupOpenCompanyName = true;
  }

  closePopupCompanyName() {
    this.popupOpenCompanyName = false;
  }

  openPopupContactName() {
    this.popupOpenContactName = true;
  }

  closePopupContactName() {
    this.popupOpenContactName = false;
  }

  setupForm(customerdata: any) {
    const countryIsocode = customerdata?.country;
    const stateIsocode = customerdata?.state;
    this.customerForm.patchValue({ ...customerdata });

    const hasCountry = this.countriesWSList?.regionsWSList?.some(x => x.isocode === countryIsocode);
    if (hasCountry) {
      this.customerForm.patchValue({ country: countryIsocode });
    }

    this.registerService.getRegions(countryIsocode).pipe(take(1)).subscribe((stateData: any) => {
      this.stateList = stateData;
      const hasState = this.stateList?.regionsWSList?.some(x => x.isocode === stateIsocode);
      if (hasState) {
        this.customerForm.get('state')?.setValue(stateIsocode, { emitEvent: true });
      } else {
        this.customerForm.get('state')?.setValue(null);
      }
    });
  }
}
